import { Menu } from './menu';

export class MenuToDisplay {
  constructor(m: Menu, displayTimeInSeconds: number) {
    this.menu = m;
    this.displayMeForXSeconds = displayTimeInSeconds;
  }

  public menu: Menu;
  public displayMeForXSeconds: number;
}
